module.exports = __webpack_public_path__ + "static/media/book7_wetenschapper.263a69b1.png";